/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import { PollerLike, PollOperationState } from "@azure/core-lro";
import {
  PutAliasRequest,
  AliasCreateOptionalParams,
  AliasCreateResponse,
  AliasGetOptionalParams,
  AliasGetResponse,
  AliasDeleteOptionalParams,
  AliasListOptionalParams,
  AliasListResponse
} from "../models/index.js";

/** Interface representing a Alias. */
export interface Alias {
  /**
   * Create Alias Subscription.
   * @param aliasName AliasName is the name for the subscription creation request. Note that this is not
   *                  the same as subscription name and this doesn’t have any other lifecycle need beyond the request for
   *                  subscription creation.
   * @param body The parameters required to create a new subscription.
   * @param options The options parameters.
   */
  beginCreate(
    aliasName: string,
    body: PutAliasRequest,
    options?: AliasCreateOptionalParams
  ): Promise<
    PollerLike<PollOperationState<AliasCreateResponse>, AliasCreateResponse>
  >;
  /**
   * Create Alias Subscription.
   * @param aliasName AliasName is the name for the subscription creation request. Note that this is not
   *                  the same as subscription name and this doesn’t have any other lifecycle need beyond the request for
   *                  subscription creation.
   * @param body The parameters required to create a new subscription.
   * @param options The options parameters.
   */
  beginCreateAndWait(
    aliasName: string,
    body: PutAliasRequest,
    options?: AliasCreateOptionalParams
  ): Promise<AliasCreateResponse>;
  /**
   * Get Alias Subscription.
   * @param aliasName AliasName is the name for the subscription creation request. Note that this is not
   *                  the same as subscription name and this doesn’t have any other lifecycle need beyond the request for
   *                  subscription creation.
   * @param options The options parameters.
   */
  get(
    aliasName: string,
    options?: AliasGetOptionalParams
  ): Promise<AliasGetResponse>;
  /**
   * Delete Alias.
   * @param aliasName AliasName is the name for the subscription creation request. Note that this is not
   *                  the same as subscription name and this doesn’t have any other lifecycle need beyond the request for
   *                  subscription creation.
   * @param options The options parameters.
   */
  delete(aliasName: string, options?: AliasDeleteOptionalParams): Promise<void>;
  /**
   * List Alias Subscription.
   * @param options The options parameters.
   */
  list(options?: AliasListOptionalParams): Promise<AliasListResponse>;
}
